// Generated by tools/pack-people.py. Do not edit.
/** Per airport-people cell, per action: a grid at (x, y) in /assets/art/people/<cell>.webp of w x h cells,
 *  one row per PEOPLE_DIRECTIONS entry and one column per frame; anchor is the ground point in a cell. */
export const PEOPLE_DIRECTIONS = ["south", "south_east", "east", "north_east", "north", "north_west", "west", "south_west"] as const;
export const PEOPLE_SCALE = 0.2;
export type PeopleAction = 'idle' | 'walk' | 'run' | 'sit';
export const PEOPLE_FRAMES: Record<string, Record<PeopleAction, { x: number; y: number; w: number; h: number; frames: number; anchor: [number, number] }>> = {"1":{"idle":{"w":72,"h":144,"frames":8,"anchor":[36.2,140.6],"x":0,"y":0},
    "walk":{"w":84,"h":148,"frames":8,"anchor":[42.2,143.2],"x":576,"y":0},
    "run":{"w":102,"h":135,"frames":6,"anchor":[50.8,133.6],"x":1248,"y":0},
    "sit":{"w":86,"h":137,"frames":8,"anchor":[42.8,126.6],"x":0,"y":1184}},

    "2":{"idle":{"w":75,"h":142,"frames":8,"anchor":[37.6,138.4],"x":0,"y":0},
    "walk":{"w":80,"h":144,"frames":8,"anchor":[40.2,136.0],"x":600,"y":0},
    "run":{"w":99,"h":149,"frames":6,"anchor":[49.6,140.6],"x":1240,"y":0},
    "sit":{"w":104,"h":134,"frames":8,"anchor":[52.2,127.4],"x":0,"y":1192}},

    "3":{"idle":{"w":82,"h":140,"frames":8,"anchor":[40.8,136.8],"x":0,"y":0},
    "walk":{"w":90,"h":144,"frames":8,"anchor":[44.8,136.8],"x":656,"y":0},
    "run":{"w":104,"h":142,"frames":6,"anchor":[52.2,139.6],"x":1376,"y":0},
    "sit":{"w":92,"h":138,"frames":8,"anchor":[45.8,126.0],"x":0,"y":1152}},

    "4":{"idle":{"w":81,"h":141,"frames":8,"anchor":[40.4,137.8],"x":0,"y":0},
    "walk":{"w":92,"h":143,"frames":8,"anchor":[46.0,136.0],"x":648,"y":0},
    "run":{"w":104,"h":141,"frames":6,"anchor":[52.2,140.0],"x":1384,"y":0},
    "sit":{"w":94,"h":138,"frames":8,"anchor":[46.8,125.6],"x":0,"y":1144}},

    "5":{"idle":{"w":78,"h":137,"frames":8,"anchor":[38.8,135.4],"x":0,"y":0},
    "walk":{"w":89,"h":143,"frames":8,"anchor":[44.6,138.0],"x":624,"y":0},
    "run":{"w":104,"h":138,"frames":6,"anchor":[52.2,135.4],"x":1336,"y":0},
    "sit":{"w":100,"h":131,"frames":8,"anchor":[50.2,124.8],"x":0,"y":1144}},

    "6":{"idle":{"w":78,"h":140,"frames":8,"anchor":[38.8,138.0],"x":0,"y":0},
    "walk":{"w":90,"h":146,"frames":8,"anchor":[45.0,141.2],"x":624,"y":0},
    "run":{"w":95,"h":134,"frames":6,"anchor":[47.4,133.0],"x":1344,"y":0},
    "sit":{"w":89,"h":134,"frames":8,"anchor":[44.4,123.0],"x":0,"y":1168}},

    "7":{"idle":{"w":82,"h":142,"frames":8,"anchor":[40.8,138.4],"x":0,"y":0},
    "walk":{"w":91,"h":143,"frames":8,"anchor":[45.6,136.4],"x":656,"y":0},
    "run":{"w":104,"h":142,"frames":6,"anchor":[52.2,141.0],"x":1384,"y":0},
    "sit":{"w":99,"h":139,"frames":8,"anchor":[49.6,125.0],"x":0,"y":1144}},

    "8":{"idle":{"w":70,"h":140,"frames":8,"anchor":[35.0,137.2],"x":0,"y":0},
    "walk":{"w":86,"h":146,"frames":8,"anchor":[43.2,139.6],"x":560,"y":0},
    "run":{"w":100,"h":141,"frames":6,"anchor":[50.0,138.8],"x":1248,"y":0},
    "sit":{"w":96,"h":134,"frames":8,"anchor":[48.2,125.2],"x":0,"y":1168}},

    "9":{"idle":{"w":78,"h":142,"frames":8,"anchor":[38.8,137.4],"x":0,"y":0},
    "walk":{"w":90,"h":144,"frames":8,"anchor":[45.0,136.2],"x":624,"y":0},
    "run":{"w":104,"h":141,"frames":6,"anchor":[52.2,138.8],"x":1344,"y":0},
    "sit":{"w":104,"h":138,"frames":8,"anchor":[52.2,121.2],"x":0,"y":1152}},

    "10":{"idle":{"w":88,"h":141,"frames":8,"anchor":[44.0,138.2],"x":0,"y":0},
    "walk":{"w":102,"h":147,"frames":8,"anchor":[51.0,137.6],"x":704,"y":0},
    "run":{"w":104,"h":144,"frames":6,"anchor":[52.2,140.8],"x":0,"y":1176},
    "sit":{"w":100,"h":140,"frames":8,"anchor":[49.8,127.2],"x":624,"y":1176}},

    "11":{"idle":{"w":90,"h":144,"frames":8,"anchor":[45.2,141.6],"x":0,"y":0},
    "walk":{"w":100,"h":153,"frames":8,"anchor":[50.0,144.0],"x":720,"y":0},
    "run":{"w":100,"h":142,"frames":6,"anchor":[50.0,136.8],"x":0,"y":1224},
    "sit":{"w":90,"h":139,"frames":8,"anchor":[45.0,128.8],"x":600,"y":1224}},

    "12":{"idle":{"w":79,"h":145,"frames":8,"anchor":[39.4,141.8],"x":0,"y":0},
    "walk":{"w":99,"h":149,"frames":8,"anchor":[49.4,138.4],"x":632,"y":0},
    "run":{"w":100,"h":148,"frames":6,"anchor":[50.0,144.4],"x":1424,"y":0},
    "sit":{"w":91,"h":142,"frames":8,"anchor":[45.4,128.8],"x":0,"y":1192}},

    "13":{"idle":{"w":82,"h":145,"frames":8,"anchor":[41.2,143.4],"x":0,"y":0},
    "walk":{"w":102,"h":148,"frames":8,"anchor":[50.8,140.4],"x":656,"y":0},
    "run":{"w":101,"h":149,"frames":6,"anchor":[50.4,146.4],"x":0,"y":1184},
    "sit":{"w":82,"h":142,"frames":8,"anchor":[41.0,133.6],"x":606,"y":1184}},

    "14":{"idle":{"w":80,"h":145,"frames":8,"anchor":[39.8,140.6],"x":0,"y":0},
    "walk":{"w":89,"h":152,"frames":8,"anchor":[44.4,143.0],"x":640,"y":0},
    "run":{"w":102,"h":139,"frames":6,"anchor":[51.0,135.2],"x":1352,"y":0},
    "sit":{"w":96,"h":137,"frames":8,"anchor":[47.8,124.6],"x":0,"y":1216}},

    "15":{"idle":{"w":80,"h":146,"frames":8,"anchor":[40.0,143.0],"x":0,"y":0},
    "walk":{"w":99,"h":150,"frames":8,"anchor":[49.6,139.6],"x":640,"y":0},
    "run":{"w":104,"h":151,"frames":6,"anchor":[52.2,146.0],"x":0,"y":1200},
    "sit":{"w":92,"h":143,"frames":8,"anchor":[45.8,131.2],"x":624,"y":1200}}};
